import { render, staticRenderFns } from "./SupportInfoTab.vue?vue&type=template&id=6cc6b402&scoped=true"
import script from "./SupportInfoTab.vue?vue&type=script&lang=js"
export * from "./SupportInfoTab.vue?vue&type=script&lang=js"
import style0 from "./SupportInfoTab.vue?vue&type=style&index=0&id=6cc6b402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc6b402",
  null
  
)

export default component.exports